import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IconButton } from "@mui/material";
import { CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import CustomConfirmation from "src/components/menuIcons/CustomConfirmation";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { page_detail_by_id } from "src/DAL/WebsitePages/WebsitePages";
import CustomMUITable from "src/components/GeneralComponents/CustomMUITable/CustomMUITable";
import {
  deletevenuesApi,
  getVenueApi,
} from "src/DAL/WebsitePages/Venues/venuesApi";

const TABLE_HEAD = [
  { id: "number", label: "#", alignRight: false, type: "number" },

  {
    id: "title",
    label: "Title",
    alignRight: false,
    type: "html",
  },
  {
    id: "general_ticket_counts",
    label: "General Tickets",
    alignRight: false,
    type: "html",
  },
  {
    id: "vip_ticket_counts",
    label: "VIP Tickets",
    alignRight: false,
    type: "html",
  },
  {
    id: "executive_ticket_counts",
    label: "Executive Tickets",
    alignRight: false,
    type: "html",
  },
  { id: "status", label: "Status", alignRight: false, type: "row_status" },
  { id: "action", label: "Action", alignRight: false, type: "action" },
];

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function VenuesList() {
  const navigate = useNavigate();
  const params = useParams();
  const classes = useStyles();
  const { state } = useLocation();
  const [successList, setSuccessList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [deleteDoc, setDeleteDoc] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [moduleData, setModuleData] = useState({});
  const [pageData, setPageData] = useState({});

  const is_website_pages = window.location.pathname.includes("website-pages");
  const module_actual_name = "vanues";

  const getWebPageFaqs = async () => {
    setIsLoading(true);
    const result = await getVenueApi(params.page_id ? params.page_id : "");
    if (result.code === 200) {
      let venus_array = [];
      if (result.vanues.length > 0) {
        venus_array = result.vanues.map((venue) => {
          let general_ticket_counts = `<div>
              <span> Total ${venue.number_of_seats}</span><br>
              <span> Booked ${venue.booked_number_of_seats}</span><br>
              <span> Available ${venue.available_number_of_seats}</span>
            </div>`;
          let vip_ticket_counts = `<div>
              <span> Total ${venue.vip_number_of_seats}</span><br>
              <span> Booked ${venue.booked_vip_number_of_seats}</span><br>
              <span> Available ${venue.available_vip_number_of_seats}</span>
            </div>`;
          let executive_ticket_counts = `<div>
              <span> Total ${venue.executive_number_of_seats}</span><br>
              <span> Booked ${venue.booked_executive_number_of_seats}</span><br>
              <span> Available ${venue.available_executive_number_of_seats}</span>
            </div>`;
          return {
            ...venue,
            general_ticket_counts: general_ticket_counts,
            vip_ticket_counts: vip_ticket_counts,
            executive_ticket_counts: executive_ticket_counts,
          };
        });
      }
      setSuccessList(venus_array);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleEdit = (value) => {
    if (params.page_id) {
      if (is_website_pages) {
        navigate(`/website-pages/${params.page_id}/edit-venues/${value._id}`, {
          state: {
            data: value,
            page_info: pageData,
          },
        });
      } else {
        navigate(`/template-pages/${params.page_id}/edit-venues/${value._id}`, {
          state: {
            data: value,
            page_info: pageData,
          },
        });
      }
    } else {
      navigate(`/website-faq/edit-faq/${value._id}`, {
        state: { data: value },
      });
    }
  };

  const handleAgreeDelete = (value) => {
    setDeleteDoc(value);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    const result = await deletevenuesApi(deleteDoc._id);
    if (result.code === 200) {
      getWebPageFaqs();
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleNavigate = () => {
    if (params.page_id) {
      if (is_website_pages) {
        navigate(`/website-pages/${params.page_id}/add-venues`, {
          state: pageData,
        });
      } else {
        navigate(`/template-pages/${params.page_id}/add-venues`, {
          state: pageData,
        });
      }
    } else {
      navigate(`/website-faq/add-faq`);
    }
  };

  const getPageDetail = async () => {
    setIsLoading(true);
    const result = await page_detail_by_id(params.page_id);
    if (result.code == 200) {
      const get_module_info = result.sale_page.module_info.filter(
        (item) => item.module_actual_name == module_actual_name
      )[0];
      setModuleData(get_module_info?.module_replica_info);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handlePageDetail = (data) => {
    setPageData(data);
    const get_module_info = data.module_info.filter(
      (item) => item.module_actual_name == module_actual_name
    )[0];
    setModuleData(get_module_info?.module_replica_info);
  };

  useEffect(() => {
    console.log(state, "statestatestatestatestatestate");
    getWebPageFaqs();
    if (params.page_id) {
      if (state) {
        handlePageDetail(state);
      } else {
        getPageDetail();
      }
    }
  }, [params.page_id]);

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: handleEdit,
    },

    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
  ];
  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <CustomConfirmation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handleDelete}
      />

      <div className="container">
        {params.page_id && (
          <div className="row">
            <div className="col-12 display-flex mb-4">
              <IconButton
                className="back-screen-button"
                onClick={() => navigate(-1)}
              >
                <ArrowBackIcon />
              </IconButton>
              <span className="sale-page-title">
                {pageData.sale_page_title}
              </span>
            </div>
          </div>
        )}
        <div className="row mb-5">
          <div className="col-lg-8 col-sm-12">
            <h2>
              {moduleData?.list_page_heading
                ? moduleData.list_page_heading
                : "Venues"}
            </h2>
          </div>
          <div className="col-lg-4 col-sm-12 text-end">
            <button onClick={handleNavigate} className="small-contained-button">
              {moduleData?.add_button_text
                ? moduleData.add_button_text
                : "Add Venue"}
            </button>
          </div>
        </div>
        <CustomMUITable
          TABLE_HEAD={TABLE_HEAD}
          data={successList}
          MENU_OPTIONS={MENU_OPTIONS}
          className="card-with-background"
        />
      </div>
    </>
  );
}
